export default "__VITE_ASSET__99bea96c__"